export const articles = [
  {
    article: {
      productName: 'Tenis de entrenamiento',
      description: 'Retaliate Puma',
      image:
        'https://www.yosicompro.com.ve/i/P/PG/388-krhFRvZtLVRnJT4IREQDIe8zdfyeUzS2.jpg',
    },
    realPrice: 8888,
    price: 3888,
    amount: 9,
    id: 1,
  },
  {
    article: {
      productName: 'Tenis de entrenamiento',
      description: 'Retaliate Puma',
      image:
        'https://www.yosicompro.com.ve/i/P/PG/388-krhFRvZtLVRnJT4IREQDIe8zdfyeUzS2.jpg',
    },
    realPrice: 8888,
    price: 3888,
    amount: 9,
    id: 2,
  },
  {
    article: {
      productName: 'Tenis de entrenamiento',
      description: 'Retaliate Puma',
      image:
        'https://www.yosicompro.com.ve/i/P/PG/388-krhFRvZtLVRnJT4IREQDIe8zdfyeUzS2.jpg',
    },
    realPrice: 8888,
    price: 3888,
    amount: 9,
    id: 3,
  },
];
